import { useEffect, useRef, useState } from 'react';
import { Box } from 'theme-ui';

import { MasterHomepageRowStructureType } from '@/graphql/types/generated';

const ROW_TYPE_OPTIONS = [
  {
    label: 'Banner Half Panel',
    description: 'Adds Panel A & B automatically',
    value: MasterHomepageRowStructureType.CollectionBanner,
  },
  {
    label: 'Banner Carousel',
    description: 'Carousel with banner image',
    value: MasterHomepageRowStructureType.CollectionHighlightCarousel,
  },
  {
    label: 'Item Carousel',
    description: 'Regular carousel without banners',
    value: MasterHomepageRowStructureType.CollectionCarousel,
  },
] as const;

export function ActionMenuAddNewRow({
  onSelect,
}: {
  onSelect: (structureType: MasterHomepageRowStructureType) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handlePointerDown = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handlePointerDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
    };
  }, []);

  return (
    <Box ref={containerRef} sx={{ pb: 4, width: '100%', position: 'relative' }}>
      <button
        sx={{
          py: 3,
          width: '100%',
          fontWeight: 600,
          cursor: 'pointer',
          color: '#40180B',
          border: '1px dashed',
          backgroundColor: '#F9F9F7',
          borderColor: 'secondaryHighlight',
          '&:hover': {
            backgroundColor: '#F5F3EF',
          },
        }}
        onClick={() => setIsOpen((value) => !value)}
      >
        + Add New Row
      </button>
      {isOpen && (
        <Box
          sx={{
            width: 300,
            zIndex: 20,
            left: '50%',
            bg: 'background',
            border: '1px solid',
            position: 'absolute',
            bottom: 'calc(100% + 10px)',
            transform: 'translateX(-50%)',
            borderColor: 'secondaryHighlight',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.16)',
          }}
        >
          {ROW_TYPE_OPTIONS.map((option) => (
            <button
              key={option.value}
              onClick={() => {
                onSelect(option.value);
                setIsOpen(false);
              }}
              sx={{
                px: 3,
                py: 2,
                width: '100%',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: '#F5F3EF',
                },
              }}
            >
              <b>{option.label}</b>
              <div>{option.description}</div>
            </button>
          ))}
        </Box>
      )}
    </Box>
  );
}
